<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

  export default {
    name: "app",

  };
</script>

<style lang="less">
  @import url("//at.alicdn.com/t/font_2809900_q3ksfccp1jl.css");
  // @import "./assets/css/reset.css";
</style>